'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color ease .3s;\n\n  :not(:last-child) {\n    margin-right: 16px;\n  }\n\n  .socialIcon {\n    fill: #999999;\n  }\n\n  :hover {\n\n    background-color: ', ';\n\n    .socialIcon {\n      fill: ', ';\n    }\n\n  }\n'], ['\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color ease .3s;\n\n  :not(:last-child) {\n    margin-right: 16px;\n  }\n\n  .socialIcon {\n    fill: #999999;\n  }\n\n  :hover {\n\n    background-color: ', ';\n\n    .socialIcon {\n      fill: ', ';\n    }\n\n  }\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  height: ', ';\n  width: ', ';\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n'], ['\n  position: absolute;\n  height: ', ';\n  width: ', ';\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LINK = function LINK(props) {
  return _react2.default.createElement('a', props);
};
var SVG = function SVG(props) {
  return _react2.default.createElement('svg', props);
};
var Box = (0, _styledComponents2.default)(LINK)(_templateObject, function (props) {
  return props.bgColor;
}, function (props) {
  return props.fill;
});
var Svg = (0, _styledComponents2.default)(SVG)(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var SocialMediaLink = function SocialMediaLink(props) {
  return _react2.default.createElement(Box, {
    bgColor: props.bgColor,
    fill: props.fill,
    href: props.link
  }, _react2.default.createElement(Svg, {
    width: 24,
    height: 24
  }, _react2.default.createElement('path', {
    d: props.path,
    className: 'socialIcon',
    viewBox: '0 0 24 24'
  })));
};
SocialMediaLink.propTypes = {
  path: _propTypes2.default.string,
  bgColor: _propTypes2.default.string,
  fill: _propTypes2.default.string,
  link: _propTypes2.default.string
};
exports.default = SocialMediaLink;